import { fansupportPublic } from "../index";

export const getDetailedCountries = async () => {
    return fansupportPublic.get('/sport/countries')
}